import styled from 'styled-components';
import { MDBIcon } from 'mdb-react-ui-kit';

export const PageContainer = styled.main`
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: calc(100vh - 220px);
  padding: 4rem 1rem;
`;

export const ContentSection = styled.section`
  background: #ffffff;
  border-radius: 12px;
  padding: 3rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

export const PageTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #1c2237;
  margin-bottom: 1rem;
  text-align: center;
`;

export const PageSubtitle = styled.p`
  font-size: 1.1rem;
  color: #666666;
  text-align: center;
  margin-bottom: 3rem;
`;

export const SectionTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 600;
  color: #1c2237;
  margin-bottom: 1.5rem;
`;

export const SocialMediaContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
`;

export const SocialCard = styled.a`
  display: flex;
  align-items: center;
  padding: 1.5rem;
  border-radius: 12px;
  color: #ffffff;
  text-decoration: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  flex: 1;
  min-width: 250px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    color: #ffffff;
  }

  &.twitter {
    background: linear-gradient(135deg, #1da1f2 0%, #0d8bd9 100%);
  }

  &.instagram {
    background: linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  }

  &.winible {
    background: linear-gradient(135deg, #2f855a 0%, #276749 100%);
  }
`;

export const SocialIcon = styled(MDBIcon)`
  font-size: 2rem;
  margin-right: 1rem;
`;

export const SocialInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SocialTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
  color: #ffffff;
`;

export const SocialDescription = styled.p`
  font-size: 0.9rem;
  margin: 0.25rem 0 0;
  color: rgba(255, 255, 255, 0.9);
`;

export const FormContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
`;

export const FormLabel = styled.label`
  display: block;
  color: #1c2237;
  font-weight: 600;
  margin-bottom: 0.45rem;
`;

export const FormInput = styled.input`
  width: 100%;
  border: 1px solid rgba(28, 34, 55, 0.2);
  border-radius: 8px;
  padding: 0.7rem 0.85rem;
  margin-bottom: 1rem;
  font-size: 0.96rem;

  &:focus {
    outline: none;
    border-color: #7289da;
    box-shadow: 0 0 0 3px rgba(114, 137, 218, 0.2);
  }
`;

export const FormTextarea = styled.textarea`
  width: 100%;
  border: 1px solid rgba(28, 34, 55, 0.2);
  border-radius: 8px;
  padding: 0.7rem 0.85rem;
  margin-bottom: 0.75rem;
  font-size: 0.96rem;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #7289da;
    box-shadow: 0 0 0 3px rgba(114, 137, 218, 0.2);
  }
`;

export const SubmitRow = styled.div`
  margin-top: 0.5rem;
`;

export const StatusMessage = styled.div`
  background: ${({ $error }) => ($error ? '#fdecec' : '#e8f7ed')};
  border: 1px solid ${({ $error }) => ($error ? '#ef9a9a' : '#84d6a1')};
  color: ${({ $error }) => ($error ? '#b42318' : '#1f6f3f')};
  border-radius: 8px;
  padding: 0.75rem 0.9rem;
  margin-bottom: 1rem;
`;
